import { clsx } from 'clsx';

import CustomActionKanbanCard from '../../components/common/custom-action-kanban-card';

import { useNewOrderCard } from './hooks';

import useStyles from './NewKanbanCard.styles';

function NewKanbanCard(props) {
  const {
    classes = {},
    onClickCard,
    order = {},
    showChipOfBundle = false,
    totalStores,
  } = props;

  const { id, store_name } = order;
  const { isTurboqueue, handleOpenOrderDetail } = useNewOrderCard({
    order,
  });
  const _classes = useStyles();

  return (
    <CustomActionKanbanCard
      classes={{ root: clsx(_classes.root, classes?.root) }}
      onClick={handleOpenOrderDetail}
      orderID={id}
      storeName={totalStores > 1 ? store_name : null}
      showChipOfBundle={showChipOfBundle}
      showAuditableChip={order.is_auditable}
      isTurboqueue={isTurboqueue}
    />
  );
}

export default NewKanbanCard;
